import BaseApi from './BaseApi';
import LeaseholdModel from '../models/leasehold/Leasehold';
import AddWIOwnershipData from 'src/models/tract_detail/add_ownership_revised/AddWIOwnership';
import LeaseholdOwnership from 'src/models/leasehold/LeaseholdOwnership';

export interface ILeasehold {
    getLeasehold(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ): Promise<object>;
    saveLeasehold(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        leasehold: LeaseholdModel,
        jwt: string
    ): Promise<object>;
    getLeaseholds(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        jwt: string
    ): Promise<object>;
    getLeaseholdsByTract(clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string): Promise<object>;
    getContracts(
        clientNumber: number, 
        projectNumber: number, 
        ownershipId: number, 
        inHanded: boolean, 
        jwt: string
    ): Promise<object>;
    updateLeaseholds(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        leaseholds: Array<LeaseholdModel>,
        jwt: string
    ): Promise<object>;
    chooseActiveLeasehold(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ): Promise<object>;
    saveAddOwnership(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        owner: AddWIOwnershipData,
        jwt: string
    ): Promise<object>;
    // tslint:disable-next-line: max-line-length
    deleteLeasehold(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ): Promise<object>;
    // tslint:disable-next-line: max-line-length
    deleteLeaseholdOwnership(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        leaseholdOwnershipId: number,
        jwt: string
    ): Promise<object>;
    updateOwnerNote(
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        ownership: LeaseholdOwnership,
        jwt: string
    ): Promise<object>;
}

export default class Leasehold extends BaseApi implements ILeasehold {
    constructor(baseURL: string) {
        super(baseURL);
    }

    // tslint:disable: max-line-length
    getLeasehold = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/${leaseholdId}`,
            jwt
        );
    };
    saveLeasehold = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        leasehold: LeaseholdModel,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${leasehold.ownershipId}/leasehold/save-leasehold`,
            leasehold,
            jwt
        );
    };
    deleteLeasehold = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ) => {
        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/${leaseholdId}`,
            {},
            jwt
        );
    };
    getLeaseholds = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, ownershipId: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/leaseholds`,
            jwt
        );
    };
    getLeaseholdsByTract = (clientNumber: number, projectNumber: number, sectionNumber: number, tractNumber: number, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/leaseholds`,
            jwt
        );
    };
    getContracts = (clientNumber: number, projectNumber: number, ownershipId: number, inHanded: boolean, jwt: string) => {
        return this.getRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/leases/ownershipId/${ownershipId}/contracts/${inHanded}`,
            jwt
        );
    };

    saveAddOwnership = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        owner: AddWIOwnershipData,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/save-add-leasehold-ownership`,
            owner,
            jwt
        );
    };
    updateLeaseholds = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        leaseholds: Array<LeaseholdModel>,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/leaseholds`,
            leaseholds,
            jwt
        );
    };
    chooseActiveLeasehold = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        jwt: string
    ) => {
        return this.postRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/choose-active-leasehold/${leaseholdId}`,
            {},
            jwt
        );
    };

    deleteLeaseholdOwnership = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        leaseholdId: number,
        leaseholdOwnershipId: number,
        jwt: string
    ) => {
        return this.deleteRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/${leaseholdId}/delete-ownership/${leaseholdOwnershipId}`,
            {},
            jwt
        );
    };

    updateOwnerNote = (
        clientNumber: number,
        projectNumber: number,
        sectionNumber: number,
        tractNumber: number,
        ownershipId: number,
        ownership: LeaseholdOwnership,
        jwt: string
    ) => {
        // tslint:disable-next-line:max-line-length
        return this.putRequest(
            `${this.baseUrl}v1.0/clients/${clientNumber}/projects/${projectNumber}/fields/${sectionNumber}/tracts/${tractNumber}/ownership/${ownershipId}/leasehold/leasehold-ownership-note`,
            ownership,
            jwt
        );
    };
}



// WEBPACK FOOTER //
// ./src/api/Leasehold.ts